<template>
    <div class="container px-0">
        <content-header :links="header_content">
            <search-input-component
                v-if="selected === 'team'"
                placeholder="Search"
                :emit_instead="true"
                v-model="search_text"
                @submit="search"
            ></search-input-component>
        </content-header>
        <div class="row">
            <div class="col-12">
                <company-people-and-role-listing
                    v-if="selected === 'team'"
                    :loading="loading"
                    :roles="data"
                    :load_url="load_url"
                    :search="search_submit"
                    :edit_url="edit_url"
                    :delete_url="delete_url"
					:disable_url="disable_url"
                ></company-people-and-role-listing>
                <ppe-component
                    v-if="selected === 'ppe'"
                    :loading="loading"
                    :team="data"
                    :ppe_types="ppe_types"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				></ppe-component>
                <certificate-component
                    v-if="selected === 'certificates'"
                    :loading="loading"
                    :certificates="data"
                    :training_certificate_types="training_certificate_types"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				></certificate-component>
                <toolbox-talks-component
                    v-if="selected === 'toolbox_talks'"
                    :loading="loading"
                    :team="data"
                    :toolbox_talks_types="toolbox_talks_types"
                    :show_user_url="show_user_url"
                    :show_submission_url="show_submission_url"
				></toolbox-talks-component>
            </div>
        </div>
        <edit-staff-modal
            @parent_method="getData"
            ref="edit_staff_modal"
            title="Add staff to your company"
            :company_roles="company_roles"
            :edit_user = false
            :url="store_url"
        ></edit-staff-modal>
    </div>
</template>

<script>
    import EditStaffModal from "../modals/EditStaffModal";
	import SearchInputComponent from "../general_components/SearchInputComponent";
	import CompanyPeopleAndRoleListing from "../people/CompanyPeopleAndRoleListing";
    import PpeComponent from "../operations/PpeComponent"
    import CertificateComponent from "../operations/CertificatesComponent"
    import ToolboxTalksComponent from "../operations/ToolboxTalksComponent"
	export default {
		name: "CompanyPeoplePage",
		components: {EditStaffModal, CompanyPeopleAndRoleListing, SearchInputComponent, PpeComponent, CertificateComponent, ToolboxTalksComponent },
		props: [
            'selected',
            'roles',
            'load_url',
            'delete_url',
			'disable_url',
            'store_url',
            'edit_url',
            'show_user_url',
            'header_content',
            'ppe_types',
            'training_certificate_types',
            'toolbox_talks_types',
            'get_data_url',
            'company_roles',
            'show_submission_url',
        ],

        data(){
			return {
				people: [],
                search_text: '',
				search_submit: null,
                showUserModal: true,
                loading:true,
                data:{},
            }
        },

        mounted(){
            this.getData()
        },
		methods: {
            openModel() {
                this.$refs.edit_staff_modal.openModal()
            },

			search(){
				this.search_submit = this.search_text;
            },
            getData(show_loader = true){
                let _this = this;
                if(show_loader === true){
                    _this.loading = true;
                }
                axios.get(_this.get_data_url)
                    .then(function (response){
                        _this.loading = false;
                        _this.data = response.data;
                    });
                },
            }
	}
</script>
